export default __webpack_public_path__ + "static/media/image-study-board-1-w@3x.7c275924.png";